import {
  ALERT_DIALOG,
  ALERT_GO_TO_BEGINNING,
  ALERT_GO_TO_NEXT
} from "../actions/action-types";

export const alertDialogReducer = (
  state = { content: "", goToBeginning: false },
  action
) => {
  if (action.type === ALERT_DIALOG) {
    if (action.contentDialog === null) {
      return {
        ...state,
        ...{ content: action.contentDialog, goToBeginning: false }
      };
    }
    return {
      ...state,
      ...{ content: action.contentDialog }
    };
  }
  if (action.type === ALERT_GO_TO_BEGINNING) {
    return {
      ...state,
      ...{ goToBeginning: action.goToBeginning }
    };
  }
  if (action.type === ALERT_GO_TO_NEXT) {
    return {
      ...state,
      ...{ goToNext: action.goToNext }
    };
  }
  return state;
};
